<template>
  <div class="form-select-standard-country">
    <el-select v-if="!readonly" class="select" v-model="innerValue" filterable :clearable="true" :disabled="disabled" placeholder="请选择">
      <el-option
        v-for="item in finalNationalityList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <span class="read-only-box" v-else>{{currentNationalityText}}</span>
  </div>
  
</template>

<script>
import constsService from '@/services/consts-service';

export default {
  components: {},
  props: {
    value: {
      type: String,
    },
    readonly: Boolean,
    fieldConfig: Object,
    disabled: Boolean,
  },
  data() {
    return {
      nationalityList: [],
    };
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    
    
    // 过滤一些参数
    finalNationalityList() {
      let list = this.nationalityList.map(item => ({
        label: this.fieldConfig.language === 'english' ? item.en_name : item.cn_name,
        value: item.iso_code3,
      }));
      if (this.fieldConfig.notRegion) {
        // 过滤港澳台
        const regionList = ['TWN', 'HKG', 'HKG'];
        list = list.filter(item => regionList.indexOf(item.value) === -1);
      }
      if (this.fieldConfig.hideCountryList) {
        list = list.filter(
          item =>
            this.fieldConfig.hideCountryList && this.fieldConfig.hideCountryList.indexOf(item.value) === -1,
        );
      }
      return list;
    },
    currentNationalityText() {
      const item = this.finalNationalityList.find(item => item.value === this.innerValue);
      return item ? item.label : this.innerValue;
    },
  },
  created() {
    this.getNationalityList();
  },
  methods: {
    getNationalityList() {
      constsService.getNationalityList().then((data) => {
        this.nationalityList = data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.form-select-standard-country {
  width: 100%;
  .select {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/application/components/form/form-select-standard-country.vue